<bnd-button
  mode="ghost"
  aria-label="pdfs"
  [shape]="'square'"
  [badge]="(documentsList() ?? initialDocumentList())?.length ?? 0"
  badgeColor="primary"
  (click)="openDocumentDialog()"
>
  <i
    class="pi text-[var(--grey-light-icon)]"
    [class.pi-image]="iconType() === 'image'"
    [class.pi-file-pdf]="iconType() === 'document'"
    [class.text-primary]="!!(documentsList() ?? initialDocumentList())?.length"
    [style.width.px]="40"
    [style.fontSize.px]="40"
    [style.height.px]="40"
  ></i>
</bnd-button>

<ao-document-upload
  [open]="isDocumentModalOpen()"
  [data]="documentUploadData"
  (result)="onDocumentDialogResult($event)"
/>
